import React, { Component } from 'react';
import {Row, Col} from 'antd'
import MultipleSelectSearch from '../../../components/select/select'
import '../fundingLimit.less'

export default class MapProductLender extends Component {

  render() {
    const { translate, product, lenderList, isEmpty, isEmptyMessage } = this.props
    return (
      <div key={product.code}  className='product-lender-map-container'>
      <Row className='product-lender-map-title'>
          <Col>{translate('fundingLimit.ovo_admin_heading_funder_type_funding_limit').replace("${productName}", product.name)}</Col>
      </Row>
      <MultipleSelectSearch 
        className='product-lender-map-multiple-search'
        productID={product.code} 
        placeholder={"Select lenders"} 
        allOptions={lenderList}
        handleChange={this.props.handleChange}
        mappedLenders={this.props.mappedLenders}
      />
      {isEmpty ? <div className='product-lender-map-search-error'>{isEmptyMessage}</div> : <></>}
    </div>
    );
  }
}